module.exports = __webpack_public_path__ + "img/128ne.d09aeb90.svg";